import React, { useState, useEffect } from 'react';
import styles from './Checkout.module.css';
import { useCart } from '../../context/CartContext';
import { useLocation, useNavigate } from 'react-router-dom';

const Checkout = () => {
  const { cartItems } = useCart();
  const location = useLocation();
  const navigate = useNavigate();
  const directProduct = location.state?.directProduct;

  const productsToBuy = directProduct ? [directProduct] : cartItems;

  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    address: ''
  });

  useEffect(() => {
    const guestEmail = localStorage.getItem('guest_email');
    if (guestEmail) setForm(f => ({ ...f, email: guestEmail }));
  }, []);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const total = productsToBuy.reduce((sum, item) => sum + (item.price || 0) * (item.quantity || 1), 0);

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const res = await fetch('http://localhost:3001/api/orders', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...form,
          products: productsToBuy
        })
      });
      const data = await res.json();
      if (data.paymentUrl) {
        window.location.href = data.paymentUrl;
      }
    } catch (err) {
      alert('Error al procesar la orden');
    }
  };

  return (
    <div className={styles.checkoutContainer}>
      {/* Header personalizado */}
      <div className={styles.customHeader}>
        <img src="/Nexa-Globals-Hlogo-removebg-preview.png" alt="Logo" className={styles.logo} />

        <button className={styles.backButton} onClick={() => navigate(-1)}>
          ← Atrás
        </button>
      </div>
      <div className={styles.checkoutGrid}>
        {/* Columna izquierda */}
        <div className={styles.leftColumn}>
          <div className={styles.formSection}>
            <form className={styles.form} onSubmit={handleSubmit}>
              <div className={styles.row}>
                <label>
                  Nombre:
                  <input name="name" value={form.name} onChange={handleChange} required />
                </label>
                <label>
                  Teléfono:
                  <input name="phone" value={form.phone} onChange={handleChange} required />
                </label>
              </div>
              <div className={styles.row}>
                <label>
                  Dirección:
                  <input name="address" value={form.address} onChange={handleChange} required />
                </label>
                <label>
                  Correo electrónico:
                  <input name="email" value={form.email} onChange={handleChange} required disabled />
                </label>
              </div>
            </form>
          </div>
          <div className={styles.productsSection}>
            <h3>Productos</h3>
            <div className={styles.productsList}>
              {productsToBuy.map(item => (
                <div key={item.id} className={styles.productItem}>
                  <img
                    src={item.primary_image || item.image || '/placeholder-image.jpg'}
                    alt={item.name}
                    className={styles.productImage}
                  />
                  <div className={styles.productInfo}>
                    <div className={styles.productName}>{item.name}</div>
                    <div className={styles.productDesc}>{item.description}</div>
                    <div className={styles.productQty}>Cantidad: {item.quantity || 1}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* Columna derecha */}
        <div className={styles.rightColumn}>
          <div className={styles.summaryBox}>
            <h3>Resumen</h3>
            <div className={styles.summaryRow}>
              <span>Subtotal:</span>
              <span>${total.toFixed(2)}</span>
            </div>
            <div className={styles.summaryRow}>
              <span>Envío:</span>
              <span>$0.00</span>
            </div>
            <div className={styles.summaryRowTotal}>
              <span>Total:</span>
              <span>${total.toFixed(2)}</span>
            </div>
            <button
              type="button"
              className={styles.payButton}
              onClick={handleSubmit}
            >
              Pagar con Wompi
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;